
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsFuncLevelDialog extends Serenity.EntityDialog<PsFuncLevelRow, any> {
        protected getFormKey() { return PsFuncLevelForm.formKey; }
        protected getIdProperty() { return PsFuncLevelRow.idProperty; }
        protected getLocalTextPrefix() { return PsFuncLevelRow.localTextPrefix; }
        protected getNameProperty() { return PsFuncLevelRow.nameProperty; }
        protected getService() { return PsFuncLevelService.baseUrl; }
        protected getDeletePermission() { return PsFuncLevelRow.deletePermission; }
        protected getInsertPermission() { return PsFuncLevelRow.insertPermission; }
        protected getUpdatePermission() { return PsFuncLevelRow.updatePermission; }

        protected form = new PsFuncLevelForm(this.idPrefix);

    }
}